import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import i18n from './lang'
console.log(i18n)
// import locale from 'element-ui/lib/locale/lang/en'
import masklayer from 'vue-masklayer'
Vue.use(masklayer)
// import QRCode from "qrcodejs2";
// Vue.use(QRCode)
Vue.config.productionTip = false
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
router.beforeEach((to, from, next) => {
  console.log(to)
  if (to.name !== 'Home' && !localStorage.getItem('token') ) { 
    console.log('111')
    next('/')
  } else {
    next()
    console.log('2222222')
  }
  // next()
})
new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
